<template>
  <WsRead
    :modelName="modelName"
    :id="$route.params.id"
    :localeMode="localeMode"
    :label="label"
    :fields="fields"
    :primary="pageSetting.primary"
    :secondary="pageSetting.secondary"
    titleKey="name"
  >
  </WsRead>
</template>

<script>
import model from "@/models/app";
export default {
  data: () => ({
    modelName: model.modelName,
    label: model.label,
    localeMode: true,
    fields: model.fields,
    pageSetting: {
      primary: [
        {
          type: "infoCard",
          floors: [
            {
              title: "資訊",
              fields: ["id", "name", "access_token"],
            },
          ],
        },
      ],
      secondary: [
        {
          type: "infoCard",
          floors: [
            {
              title: "建立資訊",
              fields: ["created_at", "created_admin"],
            },
          ],
        },
        {
          type: "infoCard",
          floors: [
            {
              title: "編輯資訊",
              fields: ["updated_at", "updated_admin"],
            },
          ],
        },
      ],
    },
  }),
};
</script>